const loadAccordion = () => {
  if (document.querySelector('.accordion')) {
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach(accordion => {
      const headers = accordion.querySelectorAll('.panel-heading');

      headers.forEach(header => {
        header.addEventListener('click', () => {
          const expanded = document.querySelectorAll('.expanded');

          if (accordion.classList.contains('expanded')) {
            accordion.classList.remove('expanded');
            accordion.style.setProperty('--panel-height', '0px');
          } else {
            accordion.classList.add('expanded');
            accordion.style.setProperty('--panel-height', '1000px');
          }

          expanded.forEach(expandedAccordion => {
            expandedAccordion.classList.remove('expanded');
            expandedAccordion.style.setProperty('--panel-height', '0px');
          });
        });
      });
    });
  }
};

export default loadAccordion;
